import { inject, observer } from "mobx-react";
import React from "react";
import Button from "../Buttons/Button";

@inject('store', 'saveStore') @observer
class ProfileIcon extends React.Component {

  onClick = () => {
    this.props.store.toggleAnyModal('loginOpen', !this.props.store.modals.loginOpen)
  }

  openModal(type){
    this.props.store.toggleAnyModal('loginOpen', false)
    this.props.store.toggleAuthModal(true, type)
  }

  handleLogout(){
    localStorage.removeItem('designId')
    localStorage.removeItem('design')
    this.props.store.handleLogout()
  }

  getBtns(){
    let btns = [
      {
        text: 'Login',
        action: () => this.openModal('login')
      },
      {
        text: 'Register',
        action: () => this.openModal('register')
      }
    ]
    if(this.props.store.auth){
      btns = [
        {
          text: 'Settings',
          action: () => this.redirectTo('dashboard/settings')
        },
        {
          text: 'My designs',
          action: () => this.redirectTo('dashboard/my-designs')
        },
        {
          text: 'Log out',
          action: () => this.handleLogout()
        },
        
      ]
    }
    return (
      btns.map((btn, idx) => (
        <div 
          key={idx}
          className="dropdown-item btn"
          onClick={btn.action}
        >
          {btn.text}
        </div>
      ))
    )
  }

  async redirectTo(path){
    await this.props.saveStore.saveDesign(true, true, this.props.store.role !== 1)
    const url = `https://mediamodifier.com/${path}`
    window.location.href = url
  }

  render() {
    const { className, store: { name, email, auth, modals } } = this.props;
    const nameStr = name ? name.slice(0, 1).toUpperCase() : ''
    return (
      <>
        <Button
          clickAction={() => this.onClick()}
          classes={`profile-icon ${className}`}
          style={{
            backgroundColor: auth ? '#3767f5a1' : '#F4F7FF',
          }}
          text={nameStr}
        />
        {
          modals.loginOpen ? (
            <div className={`user-menu dropdown show ${auth ? 'auth' : 'unauth'}`}>
              {
                <div className="dropdown-menu show">
                  {
                    auth ? (
                      <span className='user-menu__email gray'>
                        {email}
                      </span>
                    )
                    :
                    undefined
                  }
                  {this.getBtns()}
                </div>
              }
            </div>
          )
          :
          undefined
        }
      </>
    );
  }
}

export default ProfileIcon;
